<mat-tab-group
	class="tabs fill-tabs"
	color="accent"
	id="dashboard-tab-group"
	[selectedIndex]="selectedIndex"
	(selectedTabChange)="changeTab($event)">
	<mat-tab>
		<ng-template mat-tab-label>
		{{ sysText.emailTemplates.emailTemplates_header_title | uppercase }}
		</ng-template>
		<app-email-templates-table
			[isMobile]="isMobile$ | async"
			[emailTemplatesData]="emailTemplates$ | async"
			[sysText]="sysText.emailTemplates"
			[unsavedChangesSysText]="sysText.unsavedChanges"
			[isLoadingNewEmailTemplateDialog]="isLoadingNewEmailTemplateDialog$ | async"
			(createNew)="onCreate(null)"
			(onDuplicate)="onCreate($event)">
		</app-email-templates-table>
	</mat-tab>
	<mat-tab>
		<ng-template mat-tab-label>
		{{ sysText.templateDocCategories.templateDocCategories_title | uppercase }}
		</ng-template>
		<app-document-categories-tab
			[isMobile]="isMobile$ | async"
			[emailTemplatesData]="emailTemplates$ | async"
			[sysText]="sysText.templateDocCategories"
			[unsavedChangesSysText]="sysText.unsavedChanges">
		</app-document-categories-tab>
	</mat-tab>
</mat-tab-group>